module.exports = __webpack_public_path__ + "203f6277fd733ad6f92a3279e508ea6a.svg";